import * as firebase from "firebase"

const config = {
  apiKey: "AIzaSyDX877BSM-f2sjw-TcErMoQPhehwSoRMGQ",
  authDomain: "airshow-droplet.firebaseapp.com",
  databaseURL: "https://airshow-droplet.firebaseio.com",
  projectId: "airshow-droplet",
  storageBucket: "airshow-droplet.appspot.com",
  messagingSenderId: "500710947834",
  appId: "1:500710947834:web:8c90825331665603",
}

const App = firebase.initializeApp(config)

export default App
